import React, { useContext } from "react";

import { IComment } from "../../lib/models/IComment";

import CommentItem from "./CommentItem";
import { CommentsContext } from "./CommentsContext";

const CommentsList = () => {
  const { state } = useContext(CommentsContext);

  let commentsTitle: string;
  switch (state.length) {
    case 0:
      commentsTitle = "Comments";
      break;
    case 1:
      commentsTitle = "1 Comment";
      break;
    default:
      commentsTitle = `${state.length} Comments`;
      break;
  }

  return (
    <>
      <h2 className="comments__title">{commentsTitle}</h2>
      {state.length === 0 && (
        <p className="comments__none-msg">
          No comments have been posted yet. Please feel free to comment first.
        </p>
      )}
      {state.map((e: IComment) => (
        <CommentItem key={e.id} data={e} />
      ))}
    </>
  );
};

export default CommentsList;
